module.exports = __webpack_public_path__ + "static/media/t-2-q-10-4.e5edaa92.png";